/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { IREditIRResponse } from "./IREditIRResponse";

export type IREditIRResponseApiRespoonse = {
  data?: IREditIRResponse;
  status?: IREditIRResponseApiRespoonse.status;
  message?: string;
  errors?: Record<string, Array<string>>;
};

export namespace IREditIRResponseApiRespoonse {
  export enum status {
    SUCCESS = "success",
    ERROR = "error",
  }
}
